{
  "label_error-required": "Поле не заполнено",
  "label_error-invalid": "Поле заполнено неправильно",
  "label_error-int": "Значение должно быть целым числом",
  "label_error-number": "Значение должно быть числом",
  "label_error-min-length": [
    "Значение не может быть короче {{count}} символа",
    "Значение не может быть короче {{count}} символов",
    "Значение не может быть короче {{count}} символов",
    "",
    "Значение не может быть короче {{count}} символов",
    "Значение не может быть короче {{count}} символов"
  ],
  "label_error-min-length-array": [
    "Значение не может быть короче {{count}} элемента",
    "Значение не может быть короче {{count}} элементов",
    "Значение не может быть короче {{count}} элементов",
    "",
    "Значение не может быть короче {{count}} элементов",
    "Значение не может быть короче {{count}} элементов"
  ],
  "label_error-max-length": [
    "Значение не может быть длиннее {{count}} символа",
    "Значение не может быть длиннее {{count}} символов",
    "Значение не может быть длиннее {{count}} символов",
    "",
    "Значение не может быть длиннее {{count}} символов",
    "Значение не может быть длиннее {{count}} символов"
  ],
  "label_error-max-length-array": [
    "Значение не может быть длиннее {{count}} элемента",
    "Значение не может быть длиннее {{count}} элементов",
    "Значение не может быть длиннее {{count}} элементов",
    "",
    "Значение не может быть длиннее {{count}} элементов",
    "Значение не может быть длиннее {{count}} элементов"
  ],
  "label_error-min-number": "Значение должно быть числом не меньше {{count}}",
  "label_error-max-number": "Значение должно быть числом не больше {{count}}",
  "label_error-space-end": "Значение не должно заканчиваться пробелом",
  "label_error-space-start": "Значение не должно начинаться с пробела",
  "label_error-zero-start": "Значение не должно начинаться с нуля",
  "label_error-dot-end": "Значение не должно заканчиваться точкой",
  "label_delete": "Удалить",
  "button_cancel": "Закрыть",
  "button-upload_file": "Загрузить файл",
  "label-data_loaded": "Данные загружены",
  "button-generate": "Сгенерировать"
}
